import LocalText from '@/localization/local_text';

export default function MainHead({ title, mode, handleSubmit }) {
  return (
    <div className="program-board__main-header">
      <h2 className="main-header__title">{title}</h2>
      <form className="main-header__search-form" onSubmit={handleSubmit}>
        <label className="sr-only" htmlFor="search-opt">
          Choose search option
        </label>
        <select id="search-opt" className="form__select" name="searchOpt">
          <option value="titleContent">{mode === 'ko' ? '전체' : 'All'}</option>
          <option value="title">{mode === 'ko' ? '제목' : 'Title'}</option>
        </select>
        <label htmlFor="search-text" className="sr-only">
          full search
        </label>
        <input
          type="search"
          name="searchText"
          id="search-text"
          className="form__text"
          placeholder={mode === 'ko' ? '검색어를 입력하세요.' : 'Enter a search word'}
        />
        <button type="submit" className="form__btn--submit">
          <LocalText txt={'common_search_btn'} />
        </button>
      </form>
    </div>
  );
}
